const SystemInfoEndpoint = {
    COMMISSIONING_DATE: '/default/system-info/get-commissioning-date',
};
export default SystemInfoEndpoint;
